<template>
  <div>
    <!-- summary section -->
    <section
      v-if="reportData.report.ReportType === 'Compare Power by Location'"
      class="pdf-item bg-white w-full p-4 border rounded-lg bg-gray-50"
    >
      <SimpleTable
        class="mt-2"
        :title="`Location: ${reportData.report.ReportLocation1.LocationList}`"
        :tableSummary="summaryDataOne()"
        :headers="commonSummaryHeader()"
        :items="reportDataOne()"
        :options="summaryOptions"
      />
      <SimpleTable
        class="mt-2"
        :title="`Location: ${reportData.report.ReportLocation2.LocationList}`"
        :tableSummary="summaryDataTwo()"
        :headers="commonSummaryHeader()"
        :items="reportDataTwo()"
        :options="summaryOptions"
      />
    </section>
    <section
      v-else
      class="pdf-item bg-white w-full p-4 border rounded-lg bg-gray-50"
    >
      <SimpleTable
        class="mt-2"
        :title="title"
        :headers="commonSummaryHeader()"
        :items="commonSummaryData()"
        :options="summaryOptions"
      />
    </section>
  </div>
</template>
<script>
import SimpleTable from '@/components/dx/SimpleTable'
import PdfReportTemplate from '@/components/Reports/PdfReport'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    title: {
      type: String
    },
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    SimpleTable
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      assetsProperties: [],
      grouppedData: {},
      summaryOptions: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true,
        autoWidth: false
      }
    }
  },
  async mounted() {
    // await this.historicalData()
  },
  methods: {
    commonSummaryData() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ListRack.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Location'] = data.DetailITALocation.Location
        content['Total Rack'] = data.DetailSpaceAsset.TotalRack
        content['Total Contracted Power'] =
          data.DetailPowerITA.TotalContractedPower
        content['Total Average'] = data.DetailSensorDCEPower.TotalAverageStr
        content['Peak'] = data.DetailSensorDCEPower.PeakStr
        content['Unit'] = data.DetailSensorDCEPower.UnitStr
        content['Peak Time'] = data.DetailSensorDCEPower.PeakTimeStr
        content['Rack'] = data.DetailITALocation.Rack
        content['Customer'] = data.CompanyName
        // content['Min'] = data.DetailSensorDCEPower.MinimumStr
        // content['Min Time'] = data.DetailSensorDCEPower.MinimumTimeStr

        bodyData.push(content)
      })

      return bodyData
    },

    reportDataOne() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ReportLocation1.ListRack.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Location'] = data.DetailITALocation.Location
        content['Total Rack'] = data.DetailSpaceAsset.TotalRack
        content['Total Contracted Power'] =
          data.DetailPowerITA.TotalContractedPower
        content['Total Average'] = data.DetailSensorDCEPower.TotalAverageStr
        content['Peak'] = data.DetailSensorDCEPower.PeakStr
        content['Unit'] = data.DetailSensorDCEPower.UnitStr
        content['Peak Time'] = data.DetailSensorDCEPower.PeakTimeStr
        content['Rack'] = data.DetailITALocation.Rack
        content['Customer'] = data.CompanyName
        // content['Id'] = index
        // content['Location'] = data.DetailITALocation.Location
        // content['Rack'] = data.DetailITALocation.Rack
        // content['Customer'] = data.CompanyName
        // content['Peak Rack'] = data.DetailSensorDCEPower.PeakStr
        // content['Average'] = data.DetailSensorDCEPower.AverageStr
        // // content['Min'] = data.DetailSensorDCEPower.MinimumStr
        // content['Unit'] = data.DetailSensorDCEPower.UnitStr
        // content['Peak Time'] = data.DetailSensorDCEPower.PeakTimeStr
        // // content['Min Time'] = data.DetailSensorDCEPower.MinimumTimeStr

        bodyData.push(content)
      })

      return bodyData
    },
    reportDataTwo() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ReportLocation2.ListRack.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Location'] = data.DetailITALocation.Location
        content['Total Rack'] = data.DetailSpaceAsset.TotalRack
        content['Total Contracted Power'] =
          data.DetailPowerITA.TotalContractedPower
        content['Total Average'] = data.DetailSensorDCEPower.TotalAverageStr
        content['Peak'] = data.DetailSensorDCEPower.PeakStr
        content['Unit'] = data.DetailSensorDCEPower.UnitStr
        content['Peak Time'] = data.DetailSensorDCEPower.PeakTimeStr
        content['Rack'] = data.DetailITALocation.Rack
        content['Customer'] = data.CompanyName

        bodyData.push(content)
      })

      return bodyData
    },
    summaryDataOne() {
      return {
        isAvailable: true,
        TotalAverage: this.reportData.report.ReportLocation1.TotalAverage,
        TotalContractedPower: this.reportData.report.ReportLocation1
          .TotalContractedPower
      }
    },
    summaryDataTwo() {
      return {
        isAvailable: true,
        TotalAverage: this.reportData.report.ReportLocation2.TotalAverage,
        TotalContractedPower: this.reportData.report.ReportLocation2
          .TotalContractedPower
      }
    },
    commonSummaryHeader() {
      return [
        {
          type: 'string',
          text: 'Location',
          value: 'Location'
        },
        {
          type: 'string',
          text: 'Total Rack',
          value: 'Total Rack'
        },
        {
          type: 'string',
          text: 'Total Contracted Power',
          value: 'Total Contracted Power'
        },
        {
          type: 'string',
          text: 'Total Average',
          value: 'Total Average'
        },
        {
          type: 'string',
          text: 'Peak',
          value: 'Peak'
        },
        {
          type: 'string',
          text: 'Unit',
          value: 'Unit'
        },
        {
          type: 'string',
          text: 'Peak Rack',
          value: 'Rack'
        },
        {
          type: 'string',
          text: 'Customer',
          value: 'Customer'
        },
        {
          type: 'string',
          text: 'Peak Time',
          value: 'Peak Time'
        }
        // {
        //   type: 'string',
        //   text: 'Min Time',
        //   value: 'Min Time'
        // }
      ]
    },
    preparePdf() {
      this.$emit('pdfSource', {
        filename: this.getGeneratedFileName(),
        source: PdfReportTemplate.template
      })
    }
  }
}
</script>
